(() => {
  document.documentElement.classList.remove('no-js');

  const initMobileMenu = (scope = document) => {
    const menuButton = scope.querySelector?.('[data-mobile-menu-toggle]') || document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menuButton || !menu || menuButton.dataset.dazzlBound === 'true') return;

    menuButton.dataset.dazzlBound = 'true';
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  };

  initMobileMenu();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mobile-menu a');
    const menu = document.querySelector('[data-mobile-menu]');
    const menuButton = document.querySelector('[data-mobile-menu-toggle]');
    if (!link || !menu || !menuButton) return;
    menu.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('[data-mobile-menu]');
    const menuButton = document.querySelector('[data-mobile-menu-toggle]');
    if (!menu || !menuButton) return;
    menu.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
  });

  // Shopify's theme editor hot-swaps sections without a full page reload.
  document.addEventListener('shopify:section:load', (event) => initMobileMenu(event.target));
})();
